import React from "react";
//#region types
import { CommentBoxProps } from "models/propTypes/commentsPropTypes";
//#endregion
//#region components
import StyledButton from "../buttons/styledButton";
import { Grid, Fade } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const CommentBoxLarge: React.FC<CommentBoxProps> = (props) => {
  return (
    <Fade in={true} timeout={600}>
      <Grid
        item
        container
        direction="column"
        justifyContent="center"
        className={clsx(cssExports.commentBox, cssExports.commentBoxLargeArrow)}
      >
        <Grid container className={cssExports.commentBoxTitle}>
          {props.commentBoxTitle}
        </Grid>
        <Grid container className={cssExports.commentBoxDescription}>
          {props.commentBoxDescription}
        </Grid>

        {props.actions ? (
          <Grid container spacing={2} className={cssExports.commentBoxButtons}>
            {props.actions.map((action, index) => {
              return (
                <Grid item key={index}>
                  <StyledButton size="sm" onClick={action.onClick} disabled={action.disabled}>
                    {action.text}
                  </StyledButton>
                </Grid>
              );
            })}
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
    </Fade>
  );
};

export default CommentBoxLarge;
